import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import { Box, Grid, Typography } from '@mui/material';
import Image from 'next/image';
import { EMAIL } from 'src/logic/constants/links';

const ContactHero = () => {
  return (
    <Box
      py={8}
      style={{
        backgroundColor: '#0074FF',
        background: 'linear-gradient(93.37deg, #0074FF 0%, #005CCA 46%, #004699 100%)',
        color: '#fff',
      }}
    >
      <div className='page__content'>
        <Grid container alignItems={'center'} spacing={2}>
          <Grid xs={12} sm={12} md={12} lg={6} xl={6} item>
            <div
              style={{
                position: 'relative',
                width: '100%',
                maxWidth: '500px',
                maxHeight: '350px',
                height: 'auto',
                aspectRatio: '5 / 3.5',
              }}
            >
              <Image
                objectFit='cover'
                objectPosition={'top center'}
                layout='fill'
                src='/assets/images/sign-up/RegisterPhoto.png'
                alt=''
                style={{
                  borderRadius: '20px',
                }}
              />
            </div>
          </Grid>
          <Grid xs={12} sm={12} md={12} lg={6} xl={6} item>
            <Typography
              my={2}
              color='#fff'
              fontWeight={600}
              fontSize={{ xs: 40, lg: 64 }}
              lineHeight={0.9}
              component='h1'
            >
              Get in touch
            </Typography>
            <Typography
              my={3}
              color='#fff'
              fontWeight={400}
              fontSize={{ xs: 13, lg: 18 }}
              lineHeight={1.6}
              maxWidth={'600px'}
              sx={{ opacity: 0.9 }}
            >
              Book a free personalized demo on our website, or contact our sales team. We&apos;ll walk you through the
              platform, assess your needs, and outline next steps.
            </Typography>
            <Box sx={{ width: 'min(100%, 500px)', height: '1px', backgroundColor: '#fff', opacity: 0.2 }} mb={3}></Box>

            <Typography color='#fff' fontWeight={800} fontSize={{ xs: 13, lg: 18 }} mb={1}>
              Ronald Richards
            </Typography>
            <Box display={'flex'} alignItems={'center'} gap={1}>
              <EmailOutlinedIcon sx={{ fontSize: { xs: 20, lg: 26 } }} />
              <Typography
                color='#fff'
                fontWeight={600}
                fontSize={{ xs: 13, lg: 18 }}
                lineHeight={1}
                sx={{ textDecoration: 'underline' }}
              >
                <a href={`mailto:${EMAIL}`} style={{ all: 'unset', cursor: 'pointer' }}>
                  {EMAIL}
                </a>
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </div>
    </Box>
  );
};

export default ContactHero;
